import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { MenuCreateService } from '../../services';

export const fetchMenuCreate = createAsyncThunk(
    'menuCreate/fetchMenuCreate',
    async ({ file, title, slug, parentMenuId, menuGroupId, sort, specialField1 }) => {
        const response = await MenuCreateService(file, title, slug, parentMenuId, menuGroupId, sort, specialField1)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const menuCreateSlice = createSlice({
    name: 'menuCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuCreateSlice.reducer;
